// @owners { team: patients-team }
import { ActionSheetContext, Body, H1, Link, XsSpacing } from '@alto/design-system';
import React, { useContext } from 'react';
import { TransferLearnMoreActionSheet } from './TransferLearnMoreActionSheet';

export const TransferHeader = () => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  return (
    <>
      <H1>Transfer prescriptions</H1>
      <XsSpacing />
      <Body>Transfer from another pharmacy to Alto</Body>
      <XsSpacing />
      <Link
        onPress={() => {
          setActiveActionSheet(<TransferLearnMoreActionSheet />);
        }}
      >
        How do transfers work?
      </Link>
    </>
  );
};
